"use client";

import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
  rating: number; // e.g. 4.3
  outOf?: number; // default 5
}

export function StarRating({ rating, outOf = 5 }: StarRatingProps) {
  return (
    <div className="flex items-center gap-1 py-1">
      {Array.from({ length: outOf }).map((_, i) => {
        const filled = i + 1 <= Math.floor(rating);
        const half = !filled && i < rating;

        return (
          <Star
            key={i}
            className={cn(
              "w-4 h-4",
              filled
                ? "fill-yellow-400 text-yellow-400"
                : half
                ? "fill-yellow-400 text-gray-300 opacity-50"
                : "text-gray-300"
            )}
          />
        );
      })}
      <span className="text-sm text-gray-600 ml-1">({rating.toFixed(1)})</span>
    </div>
  );
}
